const state = {
  isEditorDoctor: false
};

const mutations = {
  setEditorDoctor(state, isEdit) {
    state.isEditorDoctor = isEdit;
  }
};

const getters = {
  isEditorDoctor: state => state.isEditorDoctor
};

export default {
  namespaced: true,
  state,
  mutations,
  getters
};
